import { NgModule } from '@angular/core';
import { BpBadgeDirective } from './badge.directive';

@NgModule({
  declarations: [
    BpBadgeDirective
  ],
  exports: [
    BpBadgeDirective
  ]
})
export class BpBadgeModule {
}
